import { useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { addErrorToast } from '../../../components/errors/toast/ToastUtils';
import { readNotifications as readNotificationsService } from '../../../services/notification/NotificationService';
import { useIntl } from 'react-intl';

interface Values {
  isLoading: boolean;
  readNotifications: (notifications: string[]) => Promise<number>;
}

const useReadNotifications = (): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const intl = useIntl();

  const readNotifications = async (notifications: string[]): Promise<number> => {
    try {
      setIsLoading(true);
      const result = await readNotificationsService(notifications);
      if (result.data === 1) {
        setIsLoading(false);
        return 1;
      } else {
        setIsLoading(false);
        addErrorToast({ message: intl.formatMessage({ id: 'errors.generic' }) });
        return 0;
      }
    } catch (error) {
      handleError(error);
      setIsLoading(false);
      return 0;
    }
  };

  return { readNotifications, isLoading };
};

export default useReadNotifications;
